import { render } from "./SettingsKokoroV10.vue?vue&type=template&id=79ca85da&scoped=true"
import script from "./SettingsKokoroV10.vue?vue&type=script&lang=js"
export * from "./SettingsKokoroV10.vue?vue&type=script&lang=js"

import "./SettingsKokoroV10.vue?vue&type=style&index=0&id=79ca85da&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79ca85da"]])

export default __exports__